import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Route, Switch } from 'react-router-dom';

import { graphql, gql, compose } from 'react-apollo';
import { withRouter } from 'react-router';

import Loader from './UI/Loader';

import SignedOutHomePage from './Pages/SignedOutHomePage';
import OrgHomePage from './Pages/OrgHomePage';
import AdminHomePage from './Pages/AdminHomePage';
import JuryHomePage from './Pages/JuryHomePage';

import PublicReportPage from './Pages/PublicReportPage';

const profileQuery = gql`
    query ProfileQuery {
        me {
            _id
            name
            email
            role
        }
    }
`;

const role2homePage = {
    townOrg: OrgHomePage,
    admin: AdminHomePage,
    jury: JuryHomePage,
};

class App extends Component {
    static propTypes = {
        data: PropTypes.shape({
            loading: PropTypes.bool.isRequired,
            me: PropTypes.object,
        }).isRequired,
        history: PropTypes.object.isRequired,
        location: PropTypes.object.isRequired,
    };

    componentWillReceiveProps(nextProps) {
        const {
            data: { loading, me },
            location,
        } = nextProps;

        if (!loading && !me && location.pathname === '/' && localStorage.getItem('signedInOnce')) {
            this.props.history.push('/signin');
        }
    }

    render() {
        const {
            data: { loading, me },
        } = this.props;
        let HomePageComponent;

        if (loading) {
            return <Loader centerX centerY />;
        }

        if (!me) {
            HomePageComponent = SignedOutHomePage;
        } else {
            HomePageComponent = role2homePage[me.role] || null;
        }

        return (
            <div className="App">
                <Switch>
                    <Route path="/report/:locale(en|ru)?/:token" component={PublicReportPage} />
                    <Route path="/" render={props => <HomePageComponent {...props} user={me} />} />
                </Switch>
            </div>
        );
    }
}

export default compose(
    withRouter,
    graphql(profileQuery)
)(App);



// WEBPACK FOOTER //
// ./src/App.js